export default "__VITE_ASSET__UHCJw4Yy__"